import type { FaireProductEntity } from "../../entity_types/product";

export const p_xr5y7nq6d3: FaireProductEntity = {
  token: "p_xr5y7nq6d3",
  type: "product",
  name: "Cece Body Wash | Half Case",
  brandToken: "b_8aa5kchc2z",
  brandName: "Homecourt",
  imageUrl:
    "https://cdn.faire.com/fastly/0fc718dc4af694496371ce62c05f8d56e08a0ada09ac17caad4e884d0d00b6a1.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/477f428fd79a28703eb3a3d57ae363d416339966d8045586c608ca48f3b86649.webp",
    "https://cdn.faire.com/fastly/cbb9ff679689bb463ac842dd8906e7ad7fbcae8043ac2202690e78752642fa0f.jpeg",
    "https://cdn.faire.com/fastly/b12610decea0487b8fea5f78be2527db35dfd2d5384d591d41da285543728438.webp",
    "https://cdn.faire.com/fastly/ddef241a913554eeb3f302ef58fc00f26a7758a81a101a53b57a9de02db27f77.webp",
  ],
  priceDollars: 20.52,
  description:
    "2024 Glamour Beauty and Wellness Award Winner – Best Body Wash\n\nSize: 10 fl oz / 295 ml\n\nDiscover why our luxury body wash was named the Best Body Wash of 2024 by Glamour. This hydrating body cleanser transforms your daily shower into a spa-like ritual—leaving skin refreshed, silky-soft, and lightly perfumed with fine fragrance.\n\n𝐖𝐡𝐲 𝐈𝐭 𝐖𝐨𝐫𝐤𝐬\n• Upcycled sugar beet extract delivers natural, sustainable moisture.\n• Organic rosella extract provides up to 72-hour hydration for long-lasting softness.\n• Vitamin B5 supports a healthy skin barrier and locks in hydration.\n• 100% plant-derived glucose smooths and strengthens skin.\n• Naturally derived polymers condition skin for a rich, creamy lather.\n\n𝐃𝐢𝐫𝐞𝐜𝐭𝐢𝐨𝐧𝐬 𝐟𝐨𝐫 𝐔𝐬𝐞\nApply generously onto wet skin, massage into a luxurious lather, then rinse thoroughly.\n\n𝐓𝐡𝐞 𝐂𝐞𝐜𝐞 𝐒𝐜𝐞𝐧𝐭\nGrounded yet addictive, Cece is our founder’s signature fragrance: a warm blend of cedarwood smoke, cardamom, cinnamon, and white leather that lingers beautifully on the skin.\n\n𝐅𝐫𝐚𝐠𝐫𝐚𝐧𝐜𝐞 𝐍𝐨𝐭𝐞𝐬:\n• Guatemalan cardamom*\n• Dried mate absolute leaves*\n• Sri Lankan cinnamon*\n• Carrot seeds and leaves\n• Indonesian patchouli oil*\n• Vetiver oil*\n\n*Eco-friendly and/or sustainably sourced",
  tags: [],
  msrpDollars: 36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-28T15:36:17.437Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
